/**
 * src/components/Layout.js
 *
 * React Component Module.
 *
 * Purpose: React UI module containing one or more components and local UI helpers. Integrates with routing via react-router-dom (navigation, params, or routes).
 *
 * Data flow (high level):
 * - UI/Caller -> this module -> downstream helpers/services -> state/response.
 */
import React from 'react';
import PenpotLandingPage from './landingcomponents/PenpotLandingPage';

/**
 * Layout.
 *
 * React component or UI helper used to render and manage local UI interactions.
 */
const Layout = () => {
  return (
    <PenpotLandingPage />
  );
};

export default Layout;
